import React from 'react';

const DownloadAds = () => {

    const downloadImgStyle = 'border-[2px] border-[#232A4E] rounded-[13px] h-[3rem] w-[10rem]';

  return (
    <div className="download">
        <div className="download-images flex">
            <img 
                src={ require("../img/App Store.png") }
                alt=''
                className={`mr-[2rem] ${downloadImgStyle}`} 
            />
            <img 
                src={ require("../img/Google Play.png") }
                alt=''
                className={downloadImgStyle} 
            />
        </div>
    </div>
  )
}

export default DownloadAds